import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { DiagnosticRating } from '@malou-io/package-utils';

import { PartnerThemeContext } from ':core/context/partner-theme.context';

@Component({
    selector: 'app-rating-chip',
    imports: [NgTemplateOutlet, TranslateModule, NgClass],
    templateUrl: './rating-chip.component.html',
    styleUrl: './rating-chip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingChipComponent {
    diagnosticRating = input.required<DiagnosticRating>();
    onlyText = input<boolean>(false);
    ratingsToShow = input<DiagnosticRating[]>([]);

    private readonly _partnerThemeContext = inject(PartnerThemeContext);
    readonly partnerTheme = this._partnerThemeContext.activeTheme;

    readonly DiagnosticRating = DiagnosticRating;
}
